/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Filters_Region1Inputs */

const en_coinvestments_filters_region1 = /** @type {(inputs: Coinvestments_Filters_Region1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geography`)
};

/**
* | output |
* | --- |
* | "Geography" |
*
* @param {Coinvestments_Filters_Region1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_filters_region1 = /** @type {((inputs?: Coinvestments_Filters_Region1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Filters_Region1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_filters_region1(inputs)
});
export { coinvestments_filters_region1 as "coInvestments_filters_region" }